import { useQuery } from 'react-query';
import { getVisitWithExaminations } from '@higo/api/lib/services/examinationService';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useGetVisitWithExams = (id: number) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.ExaminationDetails, id],
    () => getVisitWithExaminations(axios)(id),
    {
      enabled: !isNaN(id),
    },
  );
};
